/*
 * Copyright (c) 2019. Sonrai Analytics Ltd.
 * Developed by Deva Sen. & Warren Dowey & Gerard Loughran
 */

import { Component, OnDestroy, OnInit } from '@angular/core';
import { animate, query, style, transition, trigger } from '@angular/animations';
import { Subscription } from 'rxjs';
import { AuthenticationService } from '@app/services/authentication/authentication.service';

@Component({
  selector: 'app-blank-layout',
  templateUrl: './blank-layout.component.html',
  styleUrls: ['./blank.component.scss'],
  animations: [
    trigger('architectUIAnimation', [
      transition('* <=> *', [
        query(
          ':enter, :leave',
          [
            style({
              opacity: 0,
              display: 'flex',
              flex: '1',
              transform: 'translateY(-20px)',
              flexDirection: 'column',
            }),
          ],
          { optional: true }
        ),
        query(
          ':enter',
          [animate('600ms ease', style({ opacity: 1, transform: 'translateY(0)' }))],
          { optional: true }
        ),

        query(
          ':leave',
          [animate('600ms ease', style({ opacity: 0, transform: 'translateY(-20px)' }))],
          {
            optional: true,
          }
        ),
      ]),
    ]),
  ],
})
export class BlankLayoutComponent implements OnInit, OnDestroy {
  myStyle: object = {};
  myParams: object = {};
  width: number = 100;
  height: number = 100;
  options: any;
  private userSubscription: Subscription;
  constructor(public authenticationService: AuthenticationService) {}

  ngOnInit() {
    // this.options = {
    //   background: {
    //     color: {
    //       value: '#31394d',
    //     },
    //   },
    //   fpsLimit: 60,
    //   interactivity: {
    //     detectsOn: 'canvas',
    //     events: {
    //       onClick: {
    //         enable: true,
    //         mode: 'push',
    //       },
    //       onHover: {
    //         enable: true,
    //         mode: 'repulse',
    //       },
    //       resize: true,
    //     },
    //     modes: {
    //       bubble: {
    //         distance: 400,
    //         duration: 2,
    //         opacity: 0.8,
    //         size: 40,
    //         speed: 3,
    //       },
    //       push: {
    //         quantity: 4,
    //       },
    //       repulse: {
    //         distance: 200,
    //         duration: 0.4,
    //       },
    //     },
    //   },
    //   particles: {
    //     color: {
    //       value: '#2DD070',
    //     },
    //     links: {
    //       color: '#ffffff',
    //       distance: 150,
    //       enable: true,
    //       opacity: 0.5,
    //       width: 1,
    //     },
    //     collisions: {
    //       enable: true,
    //     },
    //     move: {
    //       direction: 'none',
    //       enable: true,
    //       outMode: 'bounce',
    //       random: false,
    //       speed: 6,
    //       straight: false,
    //     },
    //     number: {
    //       density: {
    //         enable: true,
    //         value_area: 800,
    //       },
    //       value: 80,
    //     },
    //     opacity: {
    //       value: 0.5,
    //     },
    //     shape: {
    //       type: 'circle',
    //     },
    //     size: {
    //       random: true,
    //       value: 5,
    //     },
    //   },
    //   detectRetina: true,
    // };
    // this.myStyle = {
    //   position: 'absolute',
    //   width: '90%',
    //   height: '90%',
    //   'z-index': -1,
    //   top: 0,
    //   left: 0,
    //   right: 0,
    //   bottom: 0,
    // };
  }

  ngOnDestroy() {
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
    }
  }
}
